import { Controller } from "@hotwired/stimulus"

// Reloads a turbo-frame on an interval until the loaded frame carries
// data-poll-done.
export default class extends Controller {
  static values = { interval: { type: Number, default: 4000 } }

  connect() {
    this.timer = setInterval(() => this.tick(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    if (this.element.hasAttribute("data-poll-done")) {
      clearInterval(this.timer)
      return
    }
    this.element.reload()
  }
}
